import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.resize()
  }

  resize() {
    const newHeight = this.element.scrollHeight
    if (newHeight > 0) {
      this.element.style.height = `${newHeight}px`
    }
  }
}
